import React,{useState, useEffect} from 'react';
import { Spin, Typography, Input, Popconfirm, Empty } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useLocation, useHistory } from 'react-router-dom';
import * as marked from "marked";

import './index.scss'
import Iconfont from '../../../components/Iconfont/Iconfont';
import Api from "../../../api";

const { Title, Text } = Typography;
const QARecord = () => {

    const history = useHistory();

    const [searchData, setSearchData] = useState({
        pageIndex: 1,
        pageSize: 20,
    });

    const [recentlyData, setRecentlyData] = useState([]);
    const [defalutRecentlyData, setDefalutRecentlyData] = useState([]);

    const [searchValue, setSearchValue] = useState("");

    const [noMore, setNoMore] = useState(false);
    const [recentlyLoading, setRecentlyLoading] = useState(false);

    useEffect(() => { 
        getList();
    }, [searchData])

    useEffect(()=>{
        if(recentlyData && recentlyData[0] && recentlyData[0].total > (searchData.pageIndex*searchData.pageSize)){
            addEventListenerF();
        }
    },[recentlyData]);


    useEffect(() => { 
        console.log('recentlyData',recentlyData)
    }, [JSON.stringify(recentlyData)])
    

    const addEventListenerF = () => {
        const dom = document.querySelector('#qaRecordListBox');
        if(dom) {
            dom.addEventListener("scroll",useFn);
        }
    }

    const removeEventListenerF = () => {
        document.querySelector('#qaRecordListBox').removeEventListener("scroll", useFn);
    }

    const useFn = () => {
        // 此处调用 加载更多函数
        isTouchBottom(handleLoadMore);
    };
 
    const isTouchBottom = (handler) => {
        let scrollTop = Math.ceil(document.querySelector('#qaRecordListBox').scrollTop);

        scrollTop = scrollTop+document.querySelector('#qaRecordListBox').clientHeight;
        let scrollHeight = document.querySelector('#qaRecordListBox').scrollHeight;

        console.log(scrollTop,document.querySelector('#qaRecordListBox').scrollHeight,"scrollTop");
        if(scrollTop >= scrollHeight){
            handler();
        }
    };

    const handleLoadMore = () => {
        
        // 为测试效果临时使用 message
        removeEventListenerF();

        load();
    };

    const getList = async() => {
        if(searchData.pageIndex === 1){
            setRecentlyLoading(true);
        }
        try {
            let res = await Api.ChatV7.getRecentQa({data:searchData});

            setRecentlyLoading(false);
            
            if (res && res.code === 0 && res.data && res.data.length > 0) {
                let historyData = [...defalutRecentlyData], data = [];
                
                if (historyData.length > 0 && searchData.pageIndex != 1) {
                    let last = historyData[historyData.length - 1];
                    let first = res.data[0];
                    if (first.dateName === last.dateName) {
                        last.recentQaMsgs = [...last.recentQaMsgs, ...first.recentQaMsgs];
                        res.data.splice(0, 1);
                    }
                    historyData = [...historyData, ...res.data];
                    historyData.map((item, index) => {
                        item.isOpen = true;
                        data.push(item)
                    })
                } else {
                    res.data.map((item, index) => {
                        item.isOpen = true;
                        data.push(item)
                    })
                }

                
                setDefalutRecentlyData(JSON.parse(JSON.stringify(data)));
                setRecentlyData(data);
                setNoMore(false);

                
            } else {
                if(searchData.pageIndex === 1){
                    setRecentlyData([]);
                    setDefalutRecentlyData([]);
                }
                setNoMore(true)
            }
        } catch {setRecentlyLoading(false);}
    }

    // v-infinite-scroll="load"

    const load = () => {
        if (!noMore) {
            let _searchData = {
                ...searchData,
                pageIndex: searchData.pageIndex + 1,
                pageSize: 20,
            }
            setSearchData(_searchData);
            setRecentlyLoading(true)
            // recentlyLoading.value = true;
            // getRecentLyList();
        }
    }

    const openList = (param) => { 
        let newList = [...recentlyData]
        newList.map(item => { 
            if (item.dateName === param.dateName) { 
                item.isOpen = !item.isOpen
            }
        })
        setRecentlyData(newList);
    }

    const onSearch = () => {
        let _searchData = {...searchData}
        _searchData.pageIndex = 1;
        _searchData.title = searchValue;
        setSearchData(_searchData)
    }

    const confirm = async(item) => {
        try {
            let res = await Api.ChatV7.deleteQaLogByIds({data:{"id":item.lmQaLogId}})
            if (res && res.code === 0) {
                getList();
            } else {
            }
        } catch {}
    }

    const viewDetails = (item) => {
        window.open("/page/knowledgeQA?lmQaLogId="+item.lmQaLogId);
    }

    return (
        <div className="qaRecordFrame">
            <div className="searchBox">
                <Title level={4} style={{color: '#707C97'}}>问答记录</Title>
                <Input 
                    allowClear
                    prefix={<SearchOutlined />}
                    placeholder="请输入内容" 
                    style={{width: '300px'}}
                    size="small"
                    onPressEnter={onSearch}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
            <Spin spinning={recentlyLoading}>
                <dvi className="qaRecordListBox" id="qaRecordListBox">
                    {
                        recentlyData.length > 0 ? <div>
                            {recentlyData.map((item, index) => { 
                                let formatContent = marked.parse(item.answer || "");
                                item.answer = formatContent;
                                return <div className="qaRecordList"  key={index}>
                                    <div 
                                        className="classifyName" 
                                        key={index}
                                        onClick={() => openList(item)}
                                    >
                                        <Iconfont type={item.isOpen ? "icon-xiala" : "icon-shangjiantou4"}/>
                                        {item.dateName}
                                    </div>

                                    <div className={item.isOpen ? "qaBox" : "qaBox hide"}>
                                        {item.recentQaMsgs.map((items,index)=>{
                                            return <div className="qaList" key={items.lmQaLogId}>
                                                <div className="question" onClick={()=>{viewDetails(items)}}>
                                                    <Iconfont type={"icon-shu1"}/>
                                                    <div className="title">{items.title}</div>
                                                    <Text type="secondary">{items.createTime}</Text>
                                                </div>
                                                <div className="answer" dangerouslySetInnerHTML={{__html: items.answer}}></div>
                                                <div className="oprations">
                                                    <Popconfirm
                                                        title="确认删除这条问答记录吗?"
                                                        onConfirm={()=>confirm(items)}
                                                        okText="确定"
                                                        cancelText="取消"
                                                        placement="left"
                                                    >
                                                        <Iconfont type={"icon-shanchu1"}/>
                                                    </Popconfirm>
                                                    
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            })}

                            {recentlyLoading && <div className="loadingMore">Loading...</div>}

                            {noMore && 
                            <div className="noMore">
                                没有更多数据了
                            </div>}
                        </div>:
                        <Empty description="暂无数据"/>
                    }
                </dvi>
            </Spin>

            

        </div>
    )
}
export default QARecord
